import * as React from 'react';
import * as LabelPrimitive from '@radix-ui/react-label';
import { cn } from '@/lib/utils';

export const Label = React.forwardRef<
  React.ComponentRef<typeof LabelPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root>
>(({ className, ...props }, ref) => (
  <LabelPrimitive.Root ref={ref} className={cn('eyebrow block cursor-default text-ink-2', className)} {...props} />
));
Label.displayName = 'Label';

export interface FieldProps {
  label: string;
  htmlFor?: string;
  /** One sentence explaining the field. Not a second label. */
  hint?: React.ReactNode;
  error?: string;
  required?: boolean;
  className?: string;
  children: React.ReactNode;
}

export function Field({ label, htmlFor, hint, error, required, className, children }: FieldProps) {
  return (
    <div className={cn('space-y-1.5', className)}>
      <div className="flex items-baseline justify-between gap-2">
        <Label htmlFor={htmlFor}>
          {label}
          {required ? <span className="ml-1 text-danger">*</span> : null}
        </Label>
      </div>
      {children}
      {error ? (
        <p className="font-mono text-tiny text-danger" role="alert">
          {error}
        </p>
      ) : hint ? (
        <p className="text-tiny leading-[16px] text-ink-3">{hint}</p>
      ) : null}
    </div>
  );
}
